export default __webpack_public_path__ + "resources/icons/d442-0a82.png";